'use strict';

import $ from 'jquery';
import $hub from '../shared/hub';

import '../Shared/legacy/features';
import '../Shared/legacy/polyfills';
import 'lazysizes';
import 'lazysizes/plugins/print/ls.print';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'jquery-scrollify';

import                       'jquery-ajax-unobtrusive';
import                       'jquery.cookie';
import aos              from 'aos';
import Stickyfill       from 'stickyfilljs';
import objectFitImages  from 'object-fit-images';
import lightbox         from '../Shared/lightbox/index';
import helpers          from '../Shared/helpers/index';
import svg4everybody    from '../Shared/svg4everybody/index';
import cookieConsent    from '../Shared/cookieconsent/index';
import video            from '../Shared/Video/index';
import sharedAngular    from '../Shared/ng/index';
import EGhelpers        from './helpers/index';
import header           from './header/index';
import tabs             from './Tabs/index';
import slider           from './Slider/index';
import persons          from './person/index';
import accordion        from './Accordion/index';
import price            from './price-table/index';
import scrollToModule   from './scroll-to-module/index';
import tempEloquaForm   from './tempEloquaForm/index';
import egAngular        from './ng/init/index';
import gotoTop          from './goto-top/index';
import popup            from './popup/index';
/* import modal            from './modal/index'; */
import uspModule from './usp';
import mediaVideo from './media';
import solutionsModule from './solutions';
import menu from './menu';
import episerverForms from './forms/episerver-forms';

global.helpers = window.helpers = helpers;

// Add an alias to the App, if we need to call App from the outside:
window.App = window.App || {};

window.App.common = {
    parallax() {
        function initSlider(mql) {
            const win = $(window);

            if (mql.matches) {
                const body = $(document.body);
                const blocks = body.find('.parallax');

                win.on('scroll.parallax.eg', function () {
                    if (blocks.length) {
                        for (let i = 0; i < blocks.length; i++) {
                            const element = blocks[i].getBoundingClientRect();

                            let position = element.top + element.height;
                            position /=
                                ($(window).scrollTop(),
                                $(window).width(),
                                $(window).height()) + element.height;
                            position = 100 * position;

                            if (position >= 0 && position <= 100) {
                                $(blocks[i]).css(
                                    'background-position',
                                    '50% ' + position + '%'
                                );
                            }
                        }
                    }
                });
            } else {
                win.off('scroll.parallax.eg');
            }
        }

        const mql = window.matchMedia('(min-width: 768px)');
        mql.addListener(initSlider);
        initSlider(mql);
    },
    popup() {
        popup.init();
    },
    /* modal() {
        modal.init();
    }, */
    overlayer() {
        lightbox.inline('.js-inline-lightbox');
    },
    video() {
        video.init();
    },
    person() {
        persons.init();
    },
    slider() {
        slider.timeline('.js-slider-timeline');
        slider.slideContentB('.js-slider');
        slider.slideContentBNav('.js-slider-nav');
        slider.slideSecondaryNews('.js-secondary-news');
        slider.solutionModuleE('.js-slider-e');
        slider.priceSlider('.js-price-slider');
        slider.customerReferencesA('.js-references-slider-a');
        slider.customerReferencesB('.js-references-slider-b');
        slider.carouselA('.js-carousel-a');
    },
    entrance() {
        $('.entrance__toggler-mobile-text').on('click', function () {
            $(this)
                .parents('.entrance__content')
                .find('.entrance__toggler-mobile')
                .slideToggle();
            $(this).toggleClass('active');
        });

        // set overflow hidden on the page-wrapper if the entrance ui is found
        const $entrance = $('section.entrance');
        const $pageWrap = $('.page-wrap');
        if ($entrance.length) $pageWrap.addClass('u-overflow-hidden');
    },
    header() {
        // header.fixed('.header');
        // header.overview('.js-overview');
        // header.scrollLine('.js-scroll-indicator');
        // header.searchBar('.js-search-bar');
        // header.mobile('.js-mobile-nav');
        header.anchor();
    },
    tabs() {
        tabs.timeline('.timeline');
        tabs.init('.js-module-tabs');
    },
    svg() {
        svg4everybody.init({
            polyfill: /Edge|Trident\/7.0/.test(navigator.userAgent) // polyfill ie11 & edge only
        });
    },
    cookieconsent() {
        cookieConsent.init('#cookieConsent');
    },
    priceTable() {
        price.featureDetails({
            feature: '.js-price-feature',
            toggle: '.js-price-feature-toggle',
            close: '.js-price-feature-close',
            details: '.js-price-feature-details',
            speed: 300
        });
        price.productActions({
            link: '.js-buy-try-button'
        });
        price.settingDetails({
            setting: '.js-cart-setting',
            toggle: '.js-cart-setting-toggle',
            details: '.js-cart-setting-details',
            speed: 300
        });
    },
    scrollToModule() {
        scrollToModule.init();
    },
    initAngular() {
        sharedAngular.init();
        egAngular.init();
    },
    pageNotFound() {
        $('.section-404').each(function () {
            import('./page-not-found/index').then((pageNotFound) => {
                pageNotFound.init(this);
            });
        });
    },
    tempEloquaForm() {
        tempEloquaForm.init();
    },
    helpers() {
        helpers.togglerClass();
        helpers.accordion();
        EGhelpers.toggler();
        EGhelpers.openHours();
    },
    accordion() {
        accordion.init('.js-faq');
    },
    validation() {
        if ($('.js-validation').length) {
            import('../Shared/validation/index').then((validation) => {
                validation.init('.js-validation');
            });
        }
    },
    sticky() {
        const elements = $('.js-sticky');
        Stickyfill.add(elements);
    },
    objectFit() {
        objectFitImages($('.js-object-fit'));
    },
    usp() {
        uspModule.init();
    },
    media() {
        mediaVideo.init();
    },
    solutions() {
        solutionsModule.init();
    },
    scrolljack() {
        const mql = window.matchMedia('(max-width: 767px)');

        function mediacheck(media) {
            if (media.matches) {
                $.scrollify.disable();
            } else {
                $.scrollify.enable();
            }
        }

        $.scrollify({
            section: '.js-fullscreen-jacking',
            updateHash: false,
            setHeights: false,
            before: function (index, elements) {
                if (index <= elements.length - 2) {
                    $.scrollify.setOptions({ offset: 0 });
                } else {
                    $.scrollify.setOptions({ offset: -60 });
                }
            }
        });

        mediacheck(mql);
        mql.addListener(mediacheck);
    },
    menu() {
        const $menu = $('.js-menu');
        const options = {
            api: {
                search: $menu.attr('data-search-url'),
                autocomplete: $menu.attr('data-search-endpoint')
            }
        };
        menu.init(options);
    },
    pardot() {
        // all pardot iframes
        const $iframes = $('.js-pardot-iframe');

        // initialize iframe resizer for each pardot iframe
        $iframes.on('load', function () {
            const iframe = $(this).get(0);
            window.iFrameResize(
                {
                    checkOrigin: true,
                    heightCalculationMethod: 'lowestElement'
                },
                iframe
            );
        });

        // manually trigger the resize event listening to the global $hub (required for chrome bug)
        $hub.on('toggle.change', function (/* event, data */) {
            $iframes.each(function () {
                $(this).get(0).iFrameResizer.resize();

                // manually trigger window resize to make tabs module work with iframe resize
                if ($(this).parents('.module-tabs__item').length) {
                    setTimeout(() => {
                        window.dispatchEvent(new Event('resize'));
                    }, 800);
                }
            });
        });
    },
    episerver() {
        episerverForms.init();
    },
    refreshAos() {
        const videoEle = $('video')[0];

        if (videoEle) {
            $(videoEle).on('canplay', function () {
                aos.refreshHard();
                console.log('video ready - aos refreshed');
            });
        }
    },

    // App.common.init runs on all pages
    init() {
        // console.log('%cINIT', 'padding:0 4px;background:#090;color:#fff', 'jQuery:', $.fn.jquery); // eslint-disable-line no-console
        this.initAngular();

        this.header();
        this.slider();
        this.tabs();
        this.svg();
        this.cookieconsent();

        this.person();
        this.entrance();
        this.video();
        this.accordion();
        this.priceTable();
        this.scrollToModule();
        this.helpers();
        this.pageNotFound();
        // this.courses();
        this.tempEloquaForm();
        this.validation();
        this.overlayer();
        this.popup();
        // this.modal();
        this.parallax();
        this.sticky();
        this.objectFit();
        this.usp();
        this.media();
        this.solutions();
        this.scrolljack();
        this.menu();
        this.pardot();
        this.episerver();

        aos.init({
            once: true,
            disable: 'mobile'
        });

        this.refreshAos();

        gotoTop('.js-goto-top');
    }
};

/**
 * Initial Application bootstrapping
 */

$(document).ready(() => {
    window.App.common.init($);
});
